import { CircularProgress } from '@mui/material';
import Stack from '@mui/material/Stack';

// ==============================|| LOADER - CIRCULAR ||============================== //

interface LoaderProps {
  size?: number | string;
  color?: string;
  height?: number | string;
}

const Loader = ({ size, color = '#5b31aa', height }: LoaderProps) => {
  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      sx={{ height: height ? height : '100dvh' }}
    >
      <CircularProgress
        size={size}
        sx={{
          color,
        }}
      />
    </Stack>
  );
};

export default Loader;
